module.exports = __webpack_public_path__ + "img/rec-03.7abce13c.jpg";